import { __extends } from "tslib";
import * as React from 'react';
import { classNames } from '@wix/answers-lib';
export var fileSelectorKey = 'file-selector';
var FileSelector = /** @class */ (function (_super) {
    __extends(FileSelector, _super);
    function FileSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setFileInputElement = function (elem) {
            _this.fileInputElem = elem;
        };
        _this.onFileChangeHandler = function (e) {
            var file = e.target.files[0];
            _this.props.onFileSelect(file);
        };
        _this.clearInput = function () {
            if (_this.fileInputElem) {
                _this.fileInputElem.value = '';
            }
        };
        _this.openFilePicker = function () {
            if (_this.fileInputElem) {
                _this.fileInputElem.click();
            }
            _this.clearInput();
        };
        return _this;
    }
    FileSelector.prototype.componentDidMount = function () {
        var _this = this;
        // couldn't find a way to simulate this so added hook for testing
        var w = window;
        w.testFileSelectHook = function (file) {
            _this.onFileChangeHandler({ target: { files: [file] } });
        };
    };
    FileSelector.prototype.render = function () {
        var props = this.props;
        var supportedTypes = props.supportedFileTypes.join(',');
        var cn = classNames('file-selector', props.className);
        return (React.createElement("div", { className: cn, onClick: this.openFilePicker },
            props.children,
            React.createElement("input", { type: 'file', ref: this.setFileInputElement, multiple: false, accept: supportedTypes, style: { display: 'none' }, onChange: this.onFileChangeHandler })));
    };
    return FileSelector;
}(React.PureComponent));
export { FileSelector };
//# sourceMappingURL=index.js.map